export const QUIZ_REQUEST = 'QUIZ_REQUEST';
export const QUIZ_SUCCESS = 'QUIZ_SUCCESS';
export const QUIZ_FAIL = 'QUIZ_FAIL';

export const CURRENT_QUIZ_REQUEST = 'CURRENT_QUIZ_REQUEST';
export const CURRENT_QUIZ_SUCCESS = 'CURRENT_QUIZ_SUCCESS';
export const CURRENT_QUIZ_FAIL = 'CURRENT_QUIZ_FAIL';
export const NEXT_QUESTION = 'NEXT_QUESTION';
export const PREVIOUS_QUESTION = 'PREVIOUS_QUESTION';
export const SELECT_OPTION = 'SELECT_OPTION';
